import { urls } from "../constants";
import api from "./api";

const getSpecialties = async () => {
  try {
    const response = await api.get(urls.getSpecialties);
    return {
      status: response.status,
      data: response.data.specialties,
      response: { specialties: response.data.specialties },
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctors = async ({ page, limit }) => {
  try {
    const response = await api.get(urls.getDoctors, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctorsFilter = async ({ text, page, limit }) => {
  try {
    const response = await api.get(urls.getDoctors, {
      params: {
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctorsByStatus = async ({ page, limit, status }) => {
  try {
    const response = await api.get(urls.getDoctorsPendingAproval, {
      params: {
        status,
        page,
        limit
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctorsByStatusFilter = async ({
  text,
  page,
  limit,
  status,
}) => {
  try {
    const response = await api.get(urls.getDoctorsPendingAproval, {
      params: {
        status,
        text,
        page,
        limit
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getDoctorAssignmentsTop = async ({ page, limit, text }) => {
  try {
    const response = await api.get(urls.getDoctorAssignmentsTop, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const exportDoctors = async () => {
  try {
    const response = await api.get(urls.exportDoctors, {
      responseType: 'blob'
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const uploadDoctors = async ({ formData }) => {
  try {
    // Axios handles Content-Type automatically for FormData
    const response = await api.post(urls.uploadDoctors, formData);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const doctorServices = Object.freeze({
  getDoctors,
  getDoctorsFilter,
  getSpecialties,
  getDoctorsByStatus,
  getDoctorsByStatusFilter,
  getDoctorAssignmentsTop,
  exportDoctors,
  uploadDoctors,
});

export default doctorServices;
